module.exports = {"attributes":{"viewBox":"0 0 28 28"},"content":"<path fill=\"#646464\" fill-rule=\"evenodd\" d=\"M15.8 1l-.2.3L13 4H5a2 2 0 0 0-2 2v17c0 1 .9 2 2 2h16c1.1 0 2-1 2-2v-9.1l3-2.9v12a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V6a5 5 0 0 1 5-5h10.8zm9 4.5l-3.3-2.9 1.9-2a2.2 2.2 0 0 1 3 0c1 1 1 2.3 0 3.2l-1.7 1.7zm-2.2 2.2L12.4 18l-3.5 1.3a.7.7 0 0 1-1-1L9.4 15l10-10.3 3.3 3z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-write.svg
// module id = 629
// module chunks = 0